import TranslationToneTrialPlaceholder from '@/shared/assets/images/translation-tone-trial.png';
import { MixpanelEvents } from '@/shared/thirdParty/mixpanel';

import { LimitedFeatureContent, ModalContent } from '../types';

const TRIAL_PLAN_CONTENT: ModalContent = {
  title: 'Unlock Translation Prompting',
  bulletsHeader: '',
  buttonText: 'Unlock Translation Prompting',
  content: {
    allowedPlanNames: ['Creator Pro', 'Business'],
    chip: {
      title: 'Get better translation control with Prompting and other Pro tools',
    },
    perfectFor: {
      title: 'Spend up to 50%',
      text: 'less time editing translations',
    },
    selectedPlan: 'Creator Pro',
    whatYouCanDo: {
      title: 'What you’ll get',
      bullets: [
        'Set formal or casual tone',
        'Add context about your product or audience',
        'Get translations that better fit your video',
      ],
    },
  },
  features: [],
  media: {
    src: TranslationToneTrialPlaceholder,
    type: 'image',
  },
  mixpanelButtonClickEvent: () => MixpanelEvents.trialFeatureUpsellModalUnlockClick({ feature: 'translationTone' }),
  mixpanelOpeningEvent: () => MixpanelEvents.trialFeatureUpsellModalShown({ feature: 'translationTone' }),
  subtitle: 'Tell Rask the tone, audience, and context before translating your video.',
};

export const TRANSLATION_TONE_CONTENT: LimitedFeatureContent = {
  trial: TRIAL_PLAN_CONTENT,
};
